import * as actionTypes from "./actionTypes";



export const setOpenCount=(cnt)=>{
    return{
        type:actionTypes.SET_COUNTOPEN,
        payload:{
            openCount:cnt
        }
    }
}

export const setPendingCount=(cnt)=>{
    return{
        type:actionTypes.SET_COUNTPENDING,
        payload:{
            pendingCount:cnt
        }
    }
}